/**
 * Canvas pattern helpers for the dashboard charts. Kept out of `chartTheme.ts`
 * (which only holds color tokens) because this is imperative canvas logic, not
 * theme data.
 */

/**
 * Diagonal-stripe canvas pattern for the "geplant" (planned Referral) bar cap.
 * Returns null on the server / before a 2D context exists, in which case the
 * caller falls back to a flat color.
 */
export function createHatchPattern(
  ctx: CanvasRenderingContext2D,
  color = "rgba(255, 120, 0, 0.55)",
): CanvasPattern | null {
  const tile = document.createElement("canvas");
  tile.width = 6;
  tile.height = 6;
  const tctx = tile.getContext("2d");
  if (!tctx) return null;
  tctx.strokeStyle = color;
  tctx.lineWidth = 1.5;
  tctx.beginPath();
  tctx.moveTo(0, 6);
  tctx.lineTo(6, 0);
  tctx.stroke();
  return ctx.createPattern(tile, "repeat");
}
